// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vk3Y","colBig":"styles_colBig__3VdAR","colSmall":"styles_colSmall__2uAJq"};